import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import CustomerConstants from "../../../../common/CustomerConstants";
import AutoCarousel from "../Common/AutoCarousel";

const HbHomePage = () => {
  const pics = [
    // { src: "/assets/img/HB/hb1.jpeg", alt: "" },
    // { src: "/assets/img/HB/hb2.jpeg", alt: "" },
    // { src: "/assets/img/HB/hb3.jpeg", alt: "" },
    { src: "/assets/img/HB/hb4.jpeg", alt: "" },
    // { src: "/assets/img/HB/hb5.jpeg", alt: "" },
    { src: "/assets/img/HB/hb6.jpeg", alt: "" },
    { src: "/assets/img/HB/hb7.jpeg", alt: "" },
    { src: "/assets/img/HB/hb8.jpeg", alt: "" },
    { src: "/assets/img/HB/hb9.jpeg", alt: "" },
    { src: "/assets/img/HB/hb10.jpeg", alt: "" },
  ];

  const navigate = useNavigate();
  const handleClick = () => navigate(CustomerConstants.CUSTOMER_V4_HB_LOGIN);

  const boxRef = useRef(null);
  const [dim, setDim] = useState({ w: 0, h: 0 });

  useLayoutEffect(() => {
    const measure = () => {
      if (!boxRef.current) return;
      const r = boxRef.current.getBoundingClientRect();
      setDim({ w: r.width, h: r.height });
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  const LEFT = "HALLEYS".split("");
  const RIGHT = "BLUE".split("");
 
  const gap = dim.w < 768 ? 16 : 40;
  const font = dim.w < 640 ? 36 : dim.w < 768 ? 48 : 60;

  const horizontalMaragin = dim.w < 640 ? 20 : 80;
  const leftX = horizontalMaragin;
  const rightStartX = dim.w - horizontalMaragin;

  // const rightX = dim.w - 80;
  const centerX = dim.w / 2;
  const centerY = dim.h / 2;
  //const rightStartX = dim.w + 50; // start outside right edge

  const colHeightLeft = LEFT.length * font + (LEFT.length - 1) * gap;
  const colStartYLeft = centerY - colHeightLeft / 2;

  const colHeightRight = RIGHT.length * font + (RIGHT.length - 1) * gap;
  const colStartYRight = centerY - colHeightRight / 2;

  const [startAnimation, setStartAnimation] = useState(false);
  const [hideLetters, setHideLetters] = useState(false);
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setStartAnimation(true), 300); // Start faster
    const t2 = setTimeout(() => setHideLetters(true), 2200); // Hide letters quickly
    const t3 = setTimeout(() => setShowLogo(true), 2300); // Show logo after letters gone
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);

  const FlyLetter = ({ ch, startX, startY, delay, className }) => {
    const dx = centerX - startX;
    const dy = centerY - startY;

    const curveX = dx * 0.6;
    const curveY = dy * 0.3 - 80;

    return (
      <motion.span
        className={`absolute select-none ${className} bg-white px-3 py-1 rounded-md shadow-md`}
        style={{ left: startX, top: startY, lineHeight: "1" }}
        initial={{ opacity: 1, x: 0, y: 0 }}
        animate={
          startAnimation
            ? {
                x: [0, curveX, dx],
                y: [0, curveY, dy],
                opacity: 0,
                scale: [1, 1.1, 0.9], // smoother scaling
              }
            : {}
        }
        transition={{
          delay,
          duration: 2.0, // slower motion
          ease: "easeInOut",
        }}
      >
        {ch}
      </motion.span>
    );
  };

  return (
    <div
      style={{
        transform: "scale(1.25)",
        transformOrigin: "top center",
        width: "80%", // prevents horizontal overflow
        margin: "0 auto", // centers your scaled component
      }}
    >
      <div
        ref={boxRef}
        className="relative w-full min-h-screen overflow-hidden"
      >
        {/* Blurred Background Carousel */}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <div className="w-full h-full">
            <AutoCarousel
              images={pics}
              interval={3500}
              transitionDuration={700}
              pauseOnHover
              height="100%"
              objectFit="cover"
              ariaLabel="Clinic highlights"
            />
          </div>
        </div>

        {/* Letters Animation - Hide after animation */}
        {!hideLetters && (
          <div className="absolute inset-0 z-20">
            {/* HALLEY (black text) */}
            {LEFT.map((ch, i) => (
              <FlyLetter
                key={`L-${i}`}
                ch={ch}
                startX={leftX}
                startY={colStartYLeft + i * (font + gap)}
                delay={i * 0.08}
                // className="text-black text-[72px] sm:text-[80px] md:text-[96px] font-extrabold"
                className="text-black text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold"
              />
            ))}
      
            {RIGHT.map((ch, i) => (
              <FlyLetter
                key={`R-${i}`}
                ch={ch}
                startX={rightStartX} // use far right
                startY={colStartYRight + i * (font + gap)}
                delay={i * 0.1 + 0.1}
                className="text-blue-600 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold"
              />
            ))}
          </div>
        )}

        {/* Logo Fade In */}
        {showLogo && (
          <motion.div
            className="absolute inset-0 flex items-center justify-center z-30"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="https://halleysblue.com/wp-content/uploads/2025/08/Logos-01-1-2048x1185.png"
              alt="HalleysBlue"
              onClick={handleClick}
              className="cursor-pointer w-52 sm:w-64 md:w-80 lg:w-96 object-contain transition transform hover:scale-105 active:scale-95 drop-shadow-lg"
            />
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default HbHomePage;
